import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { apiRequest } from "../apiService/allApi";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const ShopByBrands = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 FETCH PRODUCTS
  const fetchProducts = async () => {
    setLoading(true);

    const token = localStorage.getItem("token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    try {
      const res = await apiRequest(
        "api/products/latest-collection",
        "GET",
        null,
        headers,
      );

      if (res?.data?.products) {
        setProducts(res.data.products);
      }
    } catch (e) {
      console.error("API ERROR:", e);
      toast.error("Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // 🔹 ADD TO CART (sessionStorage + toaster)
  const addToCart = (product) => {
    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];

    // 🔴 stock khatam
    if (product.stock <= 0) {
      toast.error("❌ Product Out of Stock!");
      return;
    }

    const existing = cart.find((item) => item._id === product._id);

    if (existing) {
      // 🟡 stock limit reached
      if (existing.qty >= product.stock) {
        toast.error("out of stock!");
        return;
      }

      existing.qty += 1;
      toast.info("Quantity updated in cart 🛒");
    } else {
      cart.push({
        _id: product._id,
        name: product.title?.en,
        price: product.prices?.price,
        image: product.image?.[0],
        qty: 1,
        stock: product.stock, // ✅ important
      });

      toast.success("Product added to cart 🛒");
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  return (
    <>
      <section className="py-5 bg-light">
        <div className="featured-header">
          <div className="featured-header-inner">
            <h2 className="featured-title">Latest Collection</h2>
            <p className="featured-subtitle">
              Latest Products Latest Products Description
            </p>
          </div>
        </div>

        <div className="container">
          {loading && <p>Loading products...</p>}

          {!loading && products.length > 0 && (
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              spaceBetween={20}
              slidesPerView={4}
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 4 },
              }}
            >
              {products.map((item) => {
                const productName =
                  item.title?.en || item.slug || "Product Name";

                const discountPercent =
                  item.prices?.originalPrice > item.prices?.price
                    ? Math.round(
                        ((item.prices.originalPrice - item.prices.price) /
                          item.prices.originalPrice) *
                          100,
                      )
                    : 0;

                return (
                  <SwiperSlide key={item._id}>
                    <div className="product-card group">
                      <Link to={`/product/${item._id}`}>
                        {/* STOCK */}
                        <span className="badge stock">
                          Stock : <strong>{item.stock}</strong>
                        </span>

                        {/* DISCOUNT */}
                        {discountPercent > 0 && (
                          <span className="badge discount">
                            {discountPercent}% Off
                          </span>
                        )}

                        <div className="product-image">
                          <img src={item.image?.[0]} alt={productName} />
                        </div>

                        <div className="product-content">
                          <h2 className="product-title">{productName}</h2>

                          <div className="product-footer">
                            <div className="price">
                              <span className="current">
                                ₹{item.prices.price}
                              </span>
                              {item.prices.originalPrice && (
                                <del className="old">
                                  ₹{item.prices.originalPrice}
                                </del>
                              )}
                            </div>

                            {/* ✅ ADD TO CART BUTTON WITH TOASTER */}
                            <button
                              className="cart-btn"
                              disabled={item.stock <= 0}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                addToCart(item);
                              }}
                              aria-label="Add to cart"
                            >
                              <svg
                                viewBox="0 0 512 512"
                                width="18"
                                height="18"
                                fill="currentColor"
                              >
                                <path d="M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm156 187h-64v64h-32v-64h-64v-32h64v-64h32v64h64z" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
        </div>
      </section>

      {/* 🔔 TOAST CONTAINER */}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
    </>
  );
};

export default ShopByBrands;
